import { callExternalApi } from "./external-api.service";

const tlogApiServerUrl = process.env.REACT_APP_TLOG_API_SERVER_URL;;

export const getTeamAdminResource = async (clubId) => {
    const config = {
        url: `${tlogApiServerUrl}/api/team-admin`,
        method: "POST",
        data: { clubId},
        headers: {
            "content-type": "application/json",
          },
      };
  
    return await callExternalApi({config});
};

export const setTeamAdminResource = async (clubId, playerIds) => {
  const config = {
    url: `${tlogApiServerUrl}/api/team-admin/setTeam`,
    method: "POST",
    data: { clubId, playerIds },
    headers: {
        "content-type": "application/json",
      },
  }

  return await callExternalApi({config});
};